
import { AppService } from "app/services/app.service";
import { Pet } from "app/models/pet.model";
import { Observable } from "rxjs";

export abstract class AbPet extends AppService {
  abstract desativarPet(id: number);
  abstract getAllPets(pessoaUnidadeId: number): Observable<any>;
  abstract savePet(pet: Pet): Observable<any>;
}